import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Dropdown } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';
import { AgGridDownloadOptions } from 'common/components';

import * as memberMaintenanceActions from 'pages/member-maintenance/controllers/actions';
import * as memberMaintenanceSelectors from 'pages/member-maintenance/controllers/selectors';

import Messages from 'i18n/messages/maintenance';

const MemberMaintenanceUserExportSection = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector(
    memberMaintenanceSelectors.selectExportLoading()
  );

  const handleDownload = (fileType) => {
    //* trigger the grid's own download flow (same as member export) so the export
    //* reuses the exact request params (filters, incl. ag-grid column filters like
    //* Last Login / Username) currently driving the displayed grid rows
    const exportMemberEvent = new CustomEvent('exportMemberEvent', {
      detail: fileType,
    });
    document.dispatchEvent(exportMemberEvent);
    dispatch(memberMaintenanceActions.showExportLoading());
  };

  return (
    <Dropdown
      overlay={
        <AgGridDownloadOptions
          handleDownload={handleDownload}
          loading={isLoading}
        />
      }
      placement='bottomLeft'
      style={{ backgroundColor: '#fff' }}
    >
      <RibbonButton
        icon={<DownloadOutlined />}
        label={Messages.exportToExcel}
        disabled={isLoading}
        loading={isLoading}
      />
    </Dropdown>
  );
};

export default MemberMaintenanceUserExportSection;
